module.exports = __webpack_public_path__ + "img/1492008410.4491de91.jpg";